import type { FormTemplate } from '~/graphql/types';
import { FormTemplatesCategory } from '../..';
import slugify from 'slugify';

/**
 * Receive form templates and group them by categories
 * keywords: form, templates, group, category
 */
const groupByCategory = (
  templates: Array<FormTemplate>,
): FormTemplatesCategory =>
  templates?.reduce((acc, item) => {
    item.categories.forEach(category => {
      const slug = slugify(category).toLowerCase();
      if (acc[slug]) {
        acc[slug] = {
          ...acc[slug],
          templates: [...acc[slug].templates, item],
        };
      } else {
        acc[slug] = {
          slug,
          name: category,
          templates: [item],
        };
      }
    });

    return acc;
  }, {});

export default groupByCategory;
